module.exports = __webpack_public_path__ + "static/media/B (4).dc57863a.jpg";